import { render, staticRenderFns } from "./DevHome.vue?vue&type=template&id=5675c288"
import script from "./DevHome.vue?vue&type=script&lang=js"
export * from "./DevHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports